// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-footer[data-v-3cfa11e2]{display:none}@media (max-width: 567.98px){.mobile-footer[data-v-3cfa11e2]{display:block}}
`, "",{"version":3,"sources":["webpack://./layout/mobile-footer.vue"],"names":[],"mappings":"AACA,gCACC,YAAA,CAED,6BACC,gCACC,aAAA,CAAA","sourcesContent":["\n.mobile-footer {\n\tdisplay: none;\n}\n@media (max-width: 567.98px) {\n\t.mobile-footer {\n\t\tdisplay: block;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
